import { render, staticRenderFns } from "./SurplusesTable.vue?vue&type=template&id=14686746&scoped=true"
import script from "./SurplusesTable.vue?vue&type=script&lang=js"
export * from "./SurplusesTable.vue?vue&type=script&lang=js"
import style0 from "./SurplusesTable.vue?vue&type=style&index=0&id=14686746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14686746",
  null
  
)

export default component.exports